function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { capabilities } from '@ember/modifier';
import { set } from '@ember/object';
import { destroy, registerDestructor } from '@ember/destroyable';
import { consumeArgs, isFactory } from '../compat';
function destroyModifier(modifier) {
  modifier.willRemove();
  modifier.willDestroy();
}
export default class ClassBasedModifierManager {
  constructor(owner) {
    _defineProperty(this, "capabilities", capabilities(true ? '3.22' : '3.13'));
    this.owner = owner;
  }
  createModifier(factoryOrClass, args) {
    const Modifier = isFactory(factoryOrClass) ? factoryOrClass.class : factoryOrClass;
    const modifier = new Modifier(this.owner, args);
    registerDestructor(modifier, destroyModifier);
    return modifier;
  }
  installModifier(instance, element, args) {
    instance.element = element;
    if (true) {
      consumeArgs(args);
    }
    instance.didReceiveArguments();
    instance.didInstall();
  }
  updateModifier(instance, args) {
    // TODO: this should be an args proxy
    set(instance, 'args', args);
    if (true) {
      consumeArgs(args);
    }
    instance.didUpdateArguments();
    instance.didReceiveArguments();
  }
  destroyModifier(instance) {
    destroy(instance);
  }
}